import { ReturnsPolicy } from 'components/returns-policy';

const ReturnsPolicyContainer = ReturnsPolicy;

export { ReturnsPolicyContainer };
